import React from 'react';

import PropTypes from 'prop-types';

import { usePageMessages } from 'apps/auth/hooks/selectors';

import HistoryRecord from './HistoryRecord';
import { TransactionsHistoryList } from '../styles';

const AwaitingPayments = ({ records, getDefaultLabelText, alreadyHasAwaitingBlock, ...props }) => {
    const { labelPay } = usePageMessages();

    const getLabel = (record) => {
        return record?.customExtras?.i_paid === '1' ? labelPay : getDefaultLabelText(record);
    };
    const getAwaiting = (records) => {
        let isFirst = true;
        return (
            <>
                {records.map((record) => {
                    const li = (
                        <HistoryRecord
                            record={record}
                            alreadyHasAwaitingBlock={alreadyHasAwaitingBlock}
                            addMonth={isFirst}
                            key={record.paymentId}
                            label={getLabel(record)}
                            isNewMainScreen={props.isNewMainScreen}
                        />
                    );
                    isFirst = false;
                    return li;
                })}
            </>
        );
    };

    return <TransactionsHistoryList isNewMainScreen={props.isNewMainScreen}>{getAwaiting(records)}</TransactionsHistoryList>;
};
AwaitingPayments.propTypes = {
    records: PropTypes.array.isRequired,
};
export default AwaitingPayments;
